import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getRooms } from '../../actions/room';
import RoomItem from './RoomItem';


const AllRooms = ({
  auth,
  getRooms,
  room: {rooms},
}) => {

  useEffect(() => {
    getRooms();
  }, [getRooms]);

  return (
    <div className='container'>
    <Row xs={1} md={3} className="g-4">
        {rooms.map(room => (
            <RoomItem key={room._id} room={room} />
        ))}
    </Row>
    </div>
  )
};

AllRooms.propTypes = {
  getRooms: propTypes.func.isRequired,
  room: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
  room: state.room,
});

export default connect(mapStateToProps, { getRooms })(AllRooms);